export default __webpack_public_path__ + "static/media/white_paper.c00e4435.png";